export const HEADER_SORT_CONSTRAINTS = {
  NOT_SORTABLE: Symbol("not sortable"),
  SORTABLE_NOT_SORTED: Symbol("sortable not sorted"),
  SORTED_ASC: Symbol("sorted asc"),
  SORTED_DESC: Symbol("sorted desc"),
};
